import { resolveIdentifiers, User } from "../model/model"
import { UserCohorts } from "./UserCohort"
import { Transport, TransportRequest, TransportResponse } from "../transport/Transport"
import { UserCohortsResponseDto } from "./dto"
import { ApiCallMetrics } from "../metrics/monitoring/ApiCallMetrics"

export interface UserCohortFetcher {
  fetch(user: User): Promise<UserCohorts>
}

export class BrowserUserCohortFetcher implements UserCohortFetcher {
  constructor(private readonly url: string, private readonly transport: Transport) {}

  async fetch(user: User): Promise<UserCohorts> {
    const request = this.createRequest(user)
    const response = await this.execute(request)
    return this.handleResponse(response)
  }

  private createRequest(user: User): TransportRequest {
    const identifiers = { identifiers: resolveIdentifiers(user) }
    return TransportRequest.builder()
      .url(this.url)
      .method("POST")
      .addHeader("Content-Type", "text/plain;charset=UTF-8") // text/plain body to avoid CORS preflight
      .body(JSON.stringify(identifiers))
      .build()
  }

  private execute(request: TransportRequest): Promise<TransportResponse> {
    return ApiCallMetrics.record("get.cohorts", () => this.transport.send(request))
  }

  private handleResponse(response: TransportResponse): UserCohorts {
    if (!response.isSuccessful()) {
      throw new Error(`Http status code: ${response.statusCode}`)
    }

    if (response.body === null) {
      throw new Error("Response body is null")
    }

    const dto = JSON.parse(response.body) as UserCohortsResponseDto
    return UserCohorts.fromDto(dto)
  }
}
